financialsHandler = {
    $class1: $('.panel-image-map').find('.cls-1'),
    $svg: $('.panel-image-map').find('svg'),
    $stateImageContainer: $('.panel-image-map').find('.state-image-container'),
    $dataDetailsContainer: $('.data-details-container'),
    $dataDetails: $('.data-details'),
    $itemFunds: $('.item-funds'),
    $closePanelFunds: $('.close-panel-funds'),
    $heroSlider: $('.hero-slider'),    
    defaultHeight: 465,

    heroSlider: function(){
        let self = this;
        if (self.$heroSlider.length > 0) {
            self.$heroSlider.flickity({
                cellSelector: '.cell-slider',
                cellAlign: 'left',
                pageDots: true,
                fade: false,
                wrapAround: false,
                prevNextButtons: false,
                draggable: true,
                autoPlay: 3000,
                pauseAutoPlayOnHover: false
            })
        }
        self.calculateDots();
        
        $(window).on('resize', function(){
            self.calculateDots();
        })
    },

    calculateDots: function(){
        let wWidth = $(window).outerWidth();
        let addon  = (wWidth < 1024) ? 40 : 20;
        let bottom = (this.$heroSlider.parent().height() / 2) + addon;
         
        $pageDot   = this.$heroSlider.find('.flickity-page-dots');
        $pageDot.css('bottom', -bottom+'px');
    },

    init: function(){
        var self = this;
        var id   = '';  
        var $obj = '';

        self.heroSlider();

        self.$class1.mouseover(function() {
            $obj = $(this);
            id = $(this).attr('id');
    
            if (id === undefined) {
                id = $(this).parent().attr('id');
                $obj = $(this).parent().children();
            }

            var $img = $(self.$stateImageContainer.find('.state-datas[data-abb-state="'+id.toLowerCase()+'"]')[0]);     
            
            self.$class1.removeClass('active');
            self.$dataDetailsContainer.addClass('hide'); 

            if ($img.length > 0) {
                self.$dataDetails.removeClass('hide');
                self.$dataDetails.html( $img.html() ); 
                let isMental = $img.data('is-mental');

                self.$dataDetailsContainer.removeClass('hide');
                $obj.addClass('active');
                if (isMental) {
                    $obj.addClass('mental');    
                }
            
            } else {
                self.$dataDetails.addClass('hide');
            }
        })
        .mouseleave(function() {});

        self.$svg.mouseleave(function(){
            self.$class1.removeClass('active');
            self.$dataDetailsContainer.addClass('hide');
        })

        self.$dataDetailsContainer.find('.icon-close').on('click', function(){
            self.$dataDetailsContainer.addClass('hide');
            $obj.removeClass('active').removeClass('mental');
        });


        self.$itemFunds.on('click', function(){
            if (!$(this).hasClass('active')) {
                self.$itemFunds.removeClass('active'); 
                $(this).addClass('active');
                $(this).parent().addClass('opened');
                var id = $(this).attr('id');
                mainHandler.internalLinkScroll('#'+id, 400, -100);
            
                var $contentContainer = $(this).find('.content-container');
                var cHeight = $contentContainer.outerHeight();
                var columnCount = Math.ceil( cHeight / self.defaultHeight );
                
                if ((!$contentContainer.hasClass('three-column')) && (!$contentContainer.hasClass('two-column'))) {   
                    var $class = '';
                    if (columnCount >= 3) {
                        $class = 'three-column';
                    } else if (columnCount == 2) {
                        $class = 'two-column';
                    }        
                    $contentContainer.addClass($class);
                }
            }
        });

        self.$closePanelFunds.on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            self.$itemFunds.removeClass('active'); 
            self.$itemFunds.parent().removeClass('opened');
        });

        setTimeout(() => {
            $(window).resize();
        }, 5000);
    }
}